'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'file-certificate';
var width = 576;
var height = 512;
var aliases = ["file-award"];
var unicode = 'f5f3';
var svgPathData = ['M128 64l0 80c97.2 0 176 78.8 176 176 0 46.8-18.2 89.3-48 120.8l0 71.2 192 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L386.7 18.7C374.7 6.7 358.5 0 341.5 0L192 0c-35.3 0-64 28.7-64 64zm208-5.5L453.5 176 360 176c-13.3 0-24-10.7-24-24l0-93.5z', 'M208 419.9c29.3-23.5 48-59.5 48-99.9 0-70.7-57.3-128-128-128S0 249.3 0 320c0 40.4 18.7 76.5 48 99.9L48 525c0 10.5 8.5 19 19 19 3.3 0 6.5-.9 9.4-2.5L128 512 179.6 541.5c2.9 1.6 6.1 2.5 9.4 2.5 10.5 0 19-8.5 19-19l0-105.1zM80 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileCertificate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;